import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// ---
// Services
// ---

import { WebSocketService } from '.';
export class WebSocketModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  providers: [WebSocketService],
  declarations: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function WebSocketModule_tsickle_Closure_declarations() {
/** @type {?} */
WebSocketModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
WebSocketModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
